import {
  ADD_SOFTSKILL_COURSE,
  ADD_SOFTSKILL_COURSE_SUCCESS,
  ADD_SOFTSKILL_COURSE_CLEAN,
  ADD_SOFTSKILL_COURSE_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  course: undefined,
}

const SoftskillCourseAdd = (state = initialState, action) => {
  switch (action.type) {
    case ADD_SOFTSKILL_COURSE:
      state = {
        ...state,
        loading: true,
      }
      break
    case ADD_SOFTSKILL_COURSE_SUCCESS:
      state = {
        ...state,
        course: action.payload.course,
        loading: false,
        done: true,
      }
      break
    case ADD_SOFTSKILL_COURSE_CLEAN:
      state = initialState
      break
    case ADD_SOFTSKILL_COURSE_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default SoftskillCourseAdd
